import { c as _c } from "react/compiler-runtime";
/**
 * Custom (app-supplied) section of the DevPill. Extracted from
 * dev-pill.tsx as part of Phase 6 of the round-3 enactment plan
 * (review-9016e0cc-83b #7). Only consumed by dev-pill.tsx's PillUI.
 */
import { useClickOutside } from '@fpo3/ts-commons-ui';
import { useCallback, useEffect, useRef, useState } from 'react';
import type { CustomPillSection } from '../dev-pill';

/** Renders a single app-supplied pill section button with an optional click-outside-dismissable popup. */
export function CustomSection(t0) {
  const $ = _c(17);
  const {
    section
  } = t0;
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const close = t1;
  const dismissOnClickOutside = section.dismissOnClickOutside !== false;
  useClickOutside(wrapRef, open && dismissOnClickOutside, close);
  let t2;
  let t3;
  if ($[1] !== section) {
    t2 = () => {
      section.onRegisterOpen?.(() => setOpen(true));
    };
    t3 = [section];
    $[1] = section;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const t4 = `section${open ? " active" : ""}`;
  let t5;
  if ($[4] !== section.onClick) {
    t5 = section.onClick ?? (() => setOpen(_temp));
    $[4] = section.onClick;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== section.ariaLabel || $[7] !== section.icon || $[8] !== t4 || $[9] !== t5) {
    t6 = <button type="button" className={t4} aria-label={section.ariaLabel} onClick={t5}>{section.icon}</button>;
    $[6] = section.ariaLabel;
    $[7] = section.icon;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== open || $[12] !== section) {
    t7 = open && !section.onClick && <div className="menu-popup">{typeof section.content === "function" ? section.content(close) : section.content}</div>;
    $[11] = open;
    $[12] = section;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="section-wrap" ref={wrapRef}>{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(prev) {
  return !prev;
}